export const addProtocolToUrl = (url: string): string => {
  const trimedUrl = url.trim();
  if (!trimedUrl.startsWith('http://') && !trimedUrl.startsWith('https://')) {
    return `https://${url}`;
  }
  return trimedUrl;
};
